export { token } from './token.js';
import { getAuthorizer } from './token.js';
import * as user from './user.js';
import * as workspace from './workspace.js';
export const getApis = () => {
    const [signInWithGoogle, onAuthStateChanged] = getAuthorizer();
    return { ...user, ...workspace, signInWithGoogle, onAuthStateChanged };
};
export { WorkspaceType } from './workspace.js';
